import { render, staticRenderFns } from "./SmallCalendar.vue?vue&type=template&id=2cf77a13"
import script from "./SmallCalendar.vue?vue&type=script&lang=js"
export * from "./SmallCalendar.vue?vue&type=script&lang=js"
import style0 from "./SmallCalendar.vue?vue&type=style&index=0&id=2cf77a13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports